import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;


declare var $ ;
@Component({
	selector: 'app-user-feedback',
	templateUrl: './user-feedback.component.html',
	styleUrls: [ './user-feedback.component.css' ]
})
export class UserFeedbackComponent implements OnInit {
  
  feedbackForm:boolean = false;
  otpVerifymsg: string = "";
  otpVerifyLoader: boolean = false;
  interval:any;
  public otpTimeLimit=30;

  constructor(private fb : FormBuilder, private service : AppService,private router: Router) { }

  
  ngOnInit() {
    if(environment.production){
      this.service.sendEvents("Completeuser-feedback", "user-feedback", "User-Feedback");

      fbq('track', "CompleteUser-Feedback" , {
        content_type: "user-feedback",
        content_title: this.router.url,
      });
    }

    this.feedback.get('rating').valueChanges.subscribe((res)=>{
      $('.feedbackChange').removeClass("hide-div");
      $('.feedback-first').addClass("hide-div");
    })

    this.service.setTitle('Your Exprience With propira');
    this.service.setMetaTags({ property: "og:type", content: 'Property' });
    this.service.setMetaTags({ property: "og:title", content: 'Your Exprience With propira' }); 
    this.service.setMetaTags({ name: "keywords", content: 'Your Exprience With propira' });
    this.service.setMetaTags({ name: "description", content: 'Your Exprience With propira' });
    this.service.setMetaTags({ property: "og:description", content: 'Your Exprience With propira' }); 
  }
    
    feedback = this.fb.group({
      rating: ['', Validators.required],
      message: ['', Validators.required],
      mobile:['',[Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
      email: ['', [Validators.required, Validators.email]]
  });
  
  get feedbackControl() { return this.feedback.controls; }

  feedbackSubmit: boolean = false;
  feedbackLoader: boolean = false;
  feedbackErrorMsg: string = "";
  feedbackSuccessMsg: string = "";
  
  feedbackEnd() { 
    this.feedbackErrorMsg = "";
    this.feedbackSuccessMsg = "";
    this.feedbackSubmit = true;
    if (this.feedback.valid) {
      this.feedbackLoader = true;
      this.service.post('/feedbackEnd', this.feedback.value).subscribe(
        (data: any) => {
          if (data[0].error == '0') { 
            $('.feedbackChange').addClass("hide-div");
            $('.otpVerification').removeClass("hide-div");

            setTimeout(function () {
              $("#pass1").focus();
            }, 200);

            this.resendOtpTime=this.otpTimeLimit;
            this.strartOtpInterval();
          } else {
            this.feedbackErrorMsg = data[0].msg;
          } 
          this.feedbackLoader = false;
        }, (error: any) => {
          this.feedbackErrorMsg = error.errorDesc;
          this.feedbackLoader = false;
        }
      )
    }
  }

feedbackverify = this.fb.group({
  otp: ['', Validators.required]
});

get feedbackVerifyControl() { return this.feedbackverify.controls; }


chkFeedbackVerify(){
  this.feedbackErrorMsg = "";
  this.feedbackSuccessMsg = "";
  if(this.feedbackverify.valid){
    this.feedbackLoader=true;
    this.service.post('/verifyFeedback',{"otp":this.feedbackverify.value.otp,"mobile":this.feedback.value.mobile}).subscribe(
      data=>{
        if(data[0].error){
          this.feedbackErrorMsg=data[0].msg;
        }else{
          this.feedback.reset();
          this.feedbackverify.reset();
          $('.feedbackChange').addClass("hide-div");

        }

        this.feedbackLoader=false;
      },
      error=>{
        this.feedbackErrorMsg=error.errorDesc;
        this.feedbackLoader=false;
      }
    )
  }
}

sendOtp(type = "") {
  this.otpVerifymsg = "";
  if (type == "resend") {
    this.resendOtpTime=this.otpTimeLimit;
    this.strartOtpInterval();
    this.otpVerifyLoader = true;
  }

  var userType;

  if (this.service.isLoggedIn()) {
    userType = "old";
  } else {
    userType = "any";
  }

  this.service
    .post("/sendOtpforAnyMobile", {
      mobile: this.feedback.value.mobile,
      user_type: userType,
    })
    .subscribe(
      (data) => {
        if (data[0].error == "1") {
          this.service.messageBox("failed", data[0].msg);
        } else {
          if (type == "") {
          } else {
            this.otpVerifymsg = this.service.successMsg(data[0].msg);
          }
        }
        this.otpVerifyLoader = false;
      },
      (error) => {
        this.service.messageBox("failed", error.errorDesc);
      }
    );
}

resendOtpTime=this.otpTimeLimit;

strartOtpInterval(){
  this.interval = setInterval(() => {
    if(this.resendOtpTime>0){
      this.resendOtpTime--;
    }else{
      clearInterval(this.interval);
    }
  }, 1000);
}

ngOnDestroy(){
  if (this.interval) {
    clearInterval(this.interval);
 }
}

otpVerify() {
  this.otpVerifymsg = "";
  var otp = $("#pass1").val() + $("#pass2").val() + $("#pass3").val();
  if (!otp) {
    this.otpVerifymsg = this.service.failedMsg("Please enter OTP");
  } else {
    this.otpVerifyLoader = true;
    this.service
      .post("/otpVerifyForAnyMobile", {
        mobile: this.feedback.value.mobile,
        otp: otp,
      })
      .subscribe(
        (data) => {
          if (data[0].error == "1") {
            this.otpVerifymsg = this.service.failedMsg(data[0].msg);
          } else {
            $('.otpVerification').addClass("hide-div");
            $('.thankyouForm').removeClass("hide-div");
          }
          this.otpVerifyLoader = false;
        },
        (error) => {
          this.otpVerifymsg = this.service.failedMsg(error.errorDesc);
          this.otpVerifyLoader = false;
        }
      );
  }
}


}

